import { api } from "../client";
import { endpoints } from "../endpoints";

export const managementService = {
  importAccounts: (data, signal) => api.request({ url: endpoints.management.uploadUsers, method: "POST", data, signal }),
  resetPassword: (data, signal) => api.request({ url: endpoints.management.changePassword, method: "POST", data, signal }),
  async allGroups(signal) {
    const groups = [];
    let page = 1;
    while (true) {
      const { data } = await api.request({ url: endpoints.management.groups, params: { page }, safeRead: true, signal });
      const rows = Array.isArray(data) ? data : data.results ?? [];
      groups.push(...rows);
      if (Array.isArray(data) || (!data.next && !(Number(data.count) > groups.length)) || !rows.length) return groups;
      page += 1;
    }
  },
};
